export enum EventStatusCode {
    NewEvent = 10,
    AwaitingAcceptance = 20,
    Rejected = 30,
    AwaitingImprovements = 40,
    ReadyForApproval = 50,
    Closed = 60
}